/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {MatIconModule} from "@angular/material/icon";
import {NgfButtonDirective} from "@ng-falcon/button/ngf-button/ngf-button.directive";
import {MatDialogModule} from "@angular/material/dialog";

@Component({
    selector: 'ngf-dialog-title',
    templateUrl: './dialog-title.component.html',
    styleUrls: ['./dialog-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIconModule,
        NgfButtonDirective,
        MatDialogModule
    ]
})
export class DialogTitleComponent {
  @Input()
  dialogCloseResult: any = '';

  @Input()
  disableCloseButton = false;

}
